import React from 'react';
import './dispatch-note-details-content.scss';
import { TransporterVehicleDetails } from '../components/transporter-vehicle';
import { DestinationDetails } from '../components/destination';
import { DispatchDetails } from '../components';
import { TermsAndDelivery } from '../components/terms-of-delivery';
import { ReferenceDetails } from '../components/reference';
import {
  DocViewCard,
  EmptyStateView,
  ListSkeleton,
  PullRefreshContainer,
} from '../../components';
import { DispatchListDetailsRes } from '@zonofi/zono-money-store';
import { isEmpty } from 'lodash';
import { SVGS } from '@zonofi/seller-hub/assets';

interface DispatchNoteDetailsProps {
  dispatchNoteDetails: DispatchListDetailsRes | undefined;
  isLoading: boolean;
  onRefresh?: () => void;
  selectedTab?: number;
}

const getMimeTypeFromUrl = (url: string): string => {
  const pathname = url?.split('?')?.[0];
  const ext = pathname?.split('.')?.pop()?.toLowerCase();

  switch (ext) {
    case 'pdf':
      return 'application/pdf';
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    default:
      return 'application/octet-stream';
  }
};

export const DispatchNoteDetailsContent: React.FC<DispatchNoteDetailsProps> = ({
  dispatchNoteDetails,
  isLoading,
  onRefresh,
  selectedTab,
}) => {
  return (
    <PullRefreshContainer onRefresh={onRefresh}>
      <div className="dispatch-note-detail">
        {selectedTab === 0 &&
          (isLoading || !dispatchNoteDetails ? (
            <ListSkeleton
              height={200}
              className="dispatch-note-detail-loader"
            />
          ) : (
            <>
              <DispatchDetails dispatchNoteDetails={dispatchNoteDetails} />
              <TransporterVehicleDetails
                dispatchNoteDetails={dispatchNoteDetails}
              />
              <DestinationDetails dispatchNoteDetails={dispatchNoteDetails} />
              <TermsAndDelivery dispatchNoteDetails={dispatchNoteDetails} />
              <ReferenceDetails dispatchNoteDetails={dispatchNoteDetails} />
            </>
          ))}

        {selectedTab == 1 &&
          (isEmpty(dispatchNoteDetails?.docs?.[0]?.url) ? (
            <EmptyStateView
              imageSrc={SVGS.DispatchNoteNotFound}
              message={'No Document Available'}
            />
          ) : (
            <DocViewCard
              docs={{
                url: dispatchNoteDetails?.docs?.[0]?.url ?? '',
                subtype: dispatchNoteDetails?.docs?.[0]?.subType ?? '',
                doctype: '',
                filename: '',
                mimetype: getMimeTypeFromUrl(
                  dispatchNoteDetails?.docs?.[0]?.url ?? ''
                ),
              }}
            />
          ))}
      </div>
    </PullRefreshContainer>
  );
};
